import React, {useEffect, useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';
import createPayment from './createPayment';

export default function ({courseName, price}) {
	let user = useContext(GlobalContext).user;
	let serverOrigin = useContext(GlobalContext).serverOrigin;

	useEffect(() => {
		paypal
			.Buttons({
				createOrder: function (data, actions) {
					return createPayment(
						{
							price: price,
							serverOrigin: serverOrigin,
						},
						{
							data: data,
							actions: actions,
						}
					);
				},
				onApprove: async function (data, actions) {
					return fetch(`${serverOrigin}/paypal/exicutepayment/`, {
						method: 'post',
						headers: {
							'content-type': 'application/json',
						},
						body: JSON.stringify({
							orderID: data.orderID,
							userID: user._id,
							courseName: courseName,
						}),
					})
						.then(function (res) {
							return res.json();
						})
						.then(function (orderData) {
							if (orderData.status === 'sucessfull') {
								window.location.href = `/${courseName}`;
							} else {
								alert('Your order has faild');
							}
						})
						.catch(err => {
							console.error(err);
						})
						.finally(() => {
							alert('Your successfully purchased the course');
						});
				},
			})
			.render('#paypal-button-container');
	}, []);
	return <div id='paypal-button-container'></div>;
}
